/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore } from 'vuex';
import { getAuthorUpdate } from '@/request/https/system';

export default createStore({
  state: {
    routerList: [],
    pageSizeData: {
      pageW: 0,
      pageH: 0
    },
    upNum: 0,
    zoom: window.innerWidth < 1434 ? window.innerWidth / 1434 : 1,
    rightWidth: window.innerWidth - 598,
    userInfoData: {},
    dingtalkUserList: []
  },
  getters: {
    pageSizeData: (state) => state.pageSizeData,
    routerList: (state) => state.routerList,
    upNum: (state) => state.upNum,
    userInfoData: (state) => state.userInfoData,
    zoom: (state) => state.zoom,
    rightWidth: (state) => state.rightWidth,
    dingtalkUserList: (state) => state.dingtalkUserList
  },
  mutations: {
    getPageSizeData(state, pageSizeData) {
      state.pageSizeData = pageSizeData
    },
    setRouterList(state, routerList) {
      state.routerList = routerList
    },
    getUpdateNum(state) {
      const getAuthorUpdateData = async () => {
        const res: any = await getAuthorUpdate({});
        if (res.code == 0) state.upNum = res.data;
      };
      getAuthorUpdateData();
    },
    getUserInfoData(state, userInfoData) {
      state.userInfoData = userInfoData;
    },
    setDingtalkUserList(state, dingtalkUserList) {
      state.dingtalkUserList = dingtalkUserList;
    }
  },
  actions: {
    getPageSizeData({ commit }, pageSizeData) {
      commit('getPageSizeData', pageSizeData)
    },
    setRouterList({ commit }, routerList) {
      commit('setRouterList', routerList)
    },
    getUpdateNum({ commit }, upNum) {
      commit('getUpdateNum', upNum)
    },
    getUserInfoData({ commit }, userInfoData) {
      commit('getUserInfoData', userInfoData)
    },
    setDingtalkUserList({ commit }, dingtalkUserList) {
      commit('setDingtalkUserList', dingtalkUserList)
    }
  },
  modules: {

  }
})
